import { render, staticRenderFns } from "./NotifyTelegram.vue?vue&type=template&id=e51f1c92&scoped=true&lang=pug"
import script from "./NotifyTelegram.vue?vue&type=script&lang=js"
export * from "./NotifyTelegram.vue?vue&type=script&lang=js"
import style0 from "./NotifyTelegram.vue?vue&type=style&index=0&id=e51f1c92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51f1c92",
  null
  
)

export default component.exports